import { VITE_MCP_URL } from '@constants';

export const claudeCodeCommand = (token: string): string =>
	`claude mcp add --transport http moonchild ${VITE_MCP_URL} --header "Authorization: Bearer ${token}"`;

export const CODEX_ENV_VAR = 'MOONCHILD_MCP_TOKEN';

export const codexConfigSnippet = (token: string): string =>
	`[mcp_servers.moonchild]
url = "${VITE_MCP_URL}"

[mcp_servers.moonchild.http_headers]
Authorization = "Bearer ${token}"`;

export const codexConfigSnippetEnvVar = (): string =>
	`[mcp_servers.moonchild]
url = "${VITE_MCP_URL}"
bearer_token_env_var = "${CODEX_ENV_VAR}"`;

export const codexEnvVarExport = (token: string): string =>
	`export ${CODEX_ENV_VAR}="${token}"`;

export const cursorConfigJson = (token: string): string =>
	JSON.stringify(
		{
			url: VITE_MCP_URL,
			headers: { Authorization: `Bearer ${token}` },
		},
		null,
		2
	);

export const cursorDeepLink = (token: string): string => {
	const config = JSON.stringify({
		url: VITE_MCP_URL,
		headers: { Authorization: `Bearer ${token}` },
	});
	const base64 =
		typeof window !== 'undefined' && window.btoa
			? window.btoa(config).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
			: '';
	return `cursor://anysphere.cursor-deeplink/mcp/install?name=moonchild&config=${base64}`;
};

export const otherPrompt = (token: string): string =>
	`I want to connect my AI tool to the Moonchild MCP server.

Server URL: ${VITE_MCP_URL}
Authorization header: Bearer ${token}

Walk me through the exact steps to register this MCP server in whichever client I'm using. Ask me which client first if you need to.`;
